<!-- Demo Tag Button -->
<p-tag
    value="DEMO"
    severity="warn"
    [ngStyle]="{ cursor: 'pointer' }"
    pTooltip="Demo version. Click for more info."
    tooltipPosition="bottom"
    (click)="isVisibleDemoDialog = true"
>
    <i class="pi pi-exclamation-triangle pr-1" style="font-size: 0.75rem"></i>
</p-tag>

<!-- Demo Dialog -->
<p-dialog
    header="DEMO"
    appendTo="body"
    [modal]="true"
    [(visible)]="isVisibleDemoDialog"
    [style]="{ width: '30rem' }"
    [dismissableMask]="true"
    class="hidden"
>
    <p>
        This is a demo version of the SESAMMTOOL 3. It may include some bugs or missing
        functionalities.
    </p>
    <p>
        If you have any questions, please contact the TGRESIA team in the
        <a
            class="mr-4 footer-link no-underline text-primary"
            href="https://teams.microsoft.com/l/channel/19%3A0b7674988f2a41d09e4a34bd94f3b5ec%40thread.skype/Support%20and%20Feedback?groupId=b20c0fb0-2b11-4f41-a78a-c60fa8d141af&tenantId=3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac"
            target="_blank"
            rel="noopener noreferrer"
        >
            <u>Support Channel.</u></a
        >
    </p>
</p-dialog>
